import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, Form, Input } from "reactstrap";

const RecurrenceModal = ({ modal, onCloseClick, setSheduleData }) => {
    const [recurrenceData, setRecurrenceData] = useState({
        start: "",
        repeatEvery: 1,
        repeatType: "Week",
        selectedDays: ["M", "Tu", "W", "Th", "F"],
        end: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setRecurrenceData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleDayToggle = (day) => {
        setRecurrenceData((prevState) => {
            const days = prevState.selectedDays.includes(day)
                ? prevState.selectedDays.filter((d) => d !== day)
                : [...prevState.selectedDays, day];
            return { ...prevState, selectedDays: days };
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Recurrence Data:", recurrenceData);
        setSheduleData(recurrenceData)
        onCloseClick(); // Close modal
    };

    return (
        <Modal isOpen={modal} toggle={onCloseClick} >
            <ModalHeader tag="h4">
                Set Recurrence
                <span className="close" onClick={onCloseClick}></span>
            </ModalHeader>
            <ModalBody>
                <Form
                    className="custom-form mt-2 p-1"
                    onSubmit={handleSubmit}
                >
                    {/* Start Date */}
                    <div className="row mb-4">
                        <div className="col-12">
                            <label className="form-label">Start</label>
                            <Input
                                type="date"
                                name="start"
                                value={recurrenceData.start}
                                onChange={handleChange}
                                className="form-control"
                            />
                        </div>
                    </div>

                    {/* Repeat Every */}
                    <div className="row mb-4">
                        <div className="col-6">
                            <label className="form-label">Repeat every</label>
                            <Input
                                type="number"
                                name="repeatEvery"
                                value={recurrenceData.repeatEvery}
                                onChange={handleChange}
                                className="form-control"
                                min="1"
                            />
                        </div>
                        <div className="col-6">
                            <label className="form-label">Type</label>
                            <Input
                                type="select"
                                name="repeatType"
                                value={recurrenceData.repeatType}
                                onChange={handleChange}
                                className="form-control"
                            >
                                <option value="Day">Day</option>
                                <option value="Week">Week</option>
                                <option value="Month">Month</option>
                                <option value="Year">Year</option>
                            </Input>
                        </div>
                    </div>

                    {/* Select Days */}
                    <div className="row mb-4">
                        <div className="col-12">
                            <label className="form-label">Select Days</label>
                            <div className="d-flex justify-content-between">
                                {["Sun", "M", "Tu", "W", "Th", "F", "Sat"].map((day) => (
                                    <button
                                        key={day}
                                        type="button"
                                        className={`btn ${
                                            recurrenceData.selectedDays.includes(day)
                                                ? "btn-primary"
                                                : "btn-outline-primary"
                                        }`}
                                        onClick={() => handleDayToggle(day)}
                                    >
                                        {day}
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* End Date */}
                    <div className="row mb-4">
                        <div className="col-12">
                            <label className="form-label">End</label>
                            <Input
                                type="date"
                                name="end"
                                value={recurrenceData.end}
                                onChange={handleChange}
                                className="form-control"
                            />
                        </div>
                    </div>

                    {/* Actions */}
                    <div className="row">
                        <div className="d-flex justify-content-center">
                            <button className="btn btn-primary mx-3" type="submit">
                                Save
                            </button>
                            <button
                                className="btn btn-secondary mx-3"
                                type="button"
                                onClick={() => {
                                    onCloseClick();
                                    setRecurrenceData({
                                        start: "",
                                        repeatEvery: 1,
                                        repeatType: "Week",
                                        selectedDays: ["M", "T", "W", "T", "F"],
                                        end: "",
                                    });
                                }}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </Form>
            </ModalBody>
        </Modal>
    );
};

export default RecurrenceModal;
